import Icon from '../../components/Icon.vue'

Icon.register({"brands/servicestack":{"width":496,"height":512,"paths":[{"d":"M88 216C169.7 226.2 361.7 318.3 392 448H0C99.5 439.9 184.5 311 88 216zM120 64C152.3 99.6 167.7 147.9 166.4 197.6 249.3 231.3 373.7 321.3 400 448H496C455.3 231.9 222.8 79.5 120 64z"}]}})
